"use client";
import { jsx } from "react/jsx-runtime";
import { isBD } from "../../../utils/businessType.lib.js";
import { Text } from "@nxt-costco-com/forge-components";
import "../../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../Chrome/BrowseContext/hook.js";
import { getFormattedPrice } from "../ProductTile/ProductTileUI/CardBody/PriceGroup/Price/lib.js";
import { useProductTileData } from "../../../hooks/useProductTileData/index.js";
import { ECO_FEE_CATEGORY, ECO_FEE_EXCLUDE_TOKEN } from "./constants.js";
function EcoFee({
  locale,
  priceValue
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { normalizedData, translationsConfig, isSignedIn } = useProductTileData();
  const { isMemberOnlyItem } = normalizedData || {};
  const context = useBrowseContext();
  if (!((_a = translationsConfig == null ? void 0 : translationsConfig.translations) == null ? void 0 : _a.ecofeelabel) || !((_b = translationsConfig == null ? void 0 : translationsConfig.translations) == null ? void 0 : _b.ecofeeexcluded) || !(normalizedData == null ? void 0 : normalizedData.linkFeePrices) || !((_c = normalizedData == null ? void 0 : normalizedData.linkFeePrices) == null ? void 0 : _c.length)) {
    return null;
  }
  const location = isBD() ? (_e = (_d = context.bdDeliveryLocation) == null ? void 0 : _d.bdLocation) == null ? void 0 : _e.slice(-2) : (_f = context.deliveryLocation) == null ? void 0 : _f.state;
  if (!location) {
    return null;
  }
  if (Array.isArray(priceValue) && (priceValue == null ? void 0 : priceValue.length) === 2) {
    return null;
  }
  const productLinkFees = (_g = normalizedData.linkFeePrices) == null ? void 0 : _g.find(
    (linkFee) => !linkFee.key || linkFee.key === location
  );
  if (!productLinkFees || !productLinkFees.fees || !Array.isArray(productLinkFees.fees)) {
    return null;
  }
  const ecoFee = productLinkFees.fees.find(
    (fee) => fee.feeCategory === ECO_FEE_CATEGORY
  );
  if (!ecoFee) {
    return null;
  }
  if (ecoFee.excludeFromPrice && parseFloat(ecoFee.excludeFromPrice) > 0 && (!isMemberOnlyItem || isSignedIn)) {
    const formattedPrice = getFormattedPrice(
      locale,
      parseFloat(ecoFee.excludeFromPrice),
      false
    );
    return /* @__PURE__ */ jsx(
      Text,
      {
        uniqueId: `ecoFee_excluded_${(_h = normalizedData == null ? void 0 : normalizedData.productInfoData) == null ? void 0 : _h.partNumber}`,
        variant: "t6",
        children: translationsConfig.translations.ecofeeexcluded.replace(
          ECO_FEE_EXCLUDE_TOKEN,
          `${formattedPrice}`
        )
      }
    );
  }
  if (ecoFee.includeInPrice && parseFloat(ecoFee.includeInPrice) > 0) {
    return /* @__PURE__ */ jsx(
      Text,
      {
        uniqueId: `ecoFee_included_${(_i = normalizedData == null ? void 0 : normalizedData.productInfoData) == null ? void 0 : _i.partNumber}`,
        variant: "t6",
        children: translationsConfig.translations.ecofeelabel
      }
    );
  }
  return null;
}
export {
  EcoFee
};
